module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_3009.b5d8500e.png";